export class QueryKeyEnum {
    static DEVICE_OUTPUT = "deviceoutput";
}

export default QueryKeyEnum;
